import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapState({
      isExpandSidebar: 'isExpandSidebar',
      isShowSidebarOnMobile: 'isShowSidebarOnMobile',
      isAPNICStaff: 'isAPNICStaff'
    }),
    ...mapGetters({
      getNameByType: 'dataStore/getNameByType',
      getPrefixData: 'dataStore/getPrefixData',
      selectedASN: 'dataStore/selectedASN',
      asnData: 'dataStore/asnData',
      economyData: 'dataStore/economyData',
      regionData: 'dataStore/regionData',
      displayType: 'dataStore/displayType',
      accumulativeStatsData: 'dataStore/accumulativeStatsData',
      month: 'dataStore/month',
      showSideBar: 'showSideBar',
      accountList: 'dataStore/accountList',
      noAccount: 'dataStore/noAccount',
      noData: 'dataStore/noData',
      noASN: 'dataStore/noASN',
      asnList: 'dataStore/asnList',
      loadingData: 'dataStore/loadingData',
      oidcIsAuthenticated: 'authStore/oidcIsAuthenticated',
      isSmallerScreen: 'isSmallerScreen',
      dataReady: 'dataStore/dataReady',
      showReportWarning: 'showReportWarning',
      welcomeTourMode: 'dataStore/welcomeTourMode',
      isMobile: 'isMobile',
      isLargeScreen: 'isLargeScreen',
      isExtraLargeScreen: 'isExtraLargeScreen',
      isContextWrapped: 'isContextWrapped'
    })
  },
  methods: {
    ...mapActions({
      changeDisplayType: 'dataStore/changeDisplayType',
      selectAccount: 'dataStore/selectAccount',
      selectASN: 'dataStore/selectASN',
      toggleSideBar: 'toggleSideBar',
      displaySideBar: 'displaySideBar',
      updateScreenWidth: 'updateScreenWidth'
    }),
    ...mapMutations({
      setIsExpandSidebar: 'setIsExpandSidebar',
      setIsShowSidebarOnMobile: 'setIsShowSidebarOnMobile'
    })
  }
};
